/**
 * @description 可抽獎狀態
 */
export enum DrawStatus {
  /** 可抽獎 */
  D = 'D',
  /** 僅顯示活動資訊 */
  S = 'S',
  /** 活動暫停 */
  H = 'H'
}
